<template>
  <div class="account kbank">
    <div v-if="checkQrcode.hasQrcode">
      <div class="columns is-mobile">
        <div class="column is-5 is-one-third-mobile">
          <div class="svg"></div>
          <div class="m-t-15 bank-name-en text-center">
            <b>{{ depositAccount.bank.nameTH }}</b>
            <br />
            {{ depositAccount.bank.nameEN }}
          </div>
        </div>
        <div class="column is-7 is-two-third-mobile">
          <div class="qrcode-preview" v-html="checkQrcode.qrcode"></div>
        </div>
      </div>
      <div class="text-center">
        <b
          >{{ $t('modals.deposit.amountPla') }}
          {{ checkQrcode.amount }}
          {{ $t('modals.transfer.bahtTxt') }}</b
        >
      </div>
      <div class="field m-t-20 text-center">
        <div>{{ $t('modals.deposit.qr1Txt') }}</div>
        <div>
          {{ $t('modals.deposit.qr2Txt') }} {{ timeInterval }}
          {{ $t('modals.deposit.qr3Txt') }}
        </div>
        <div class="m-t-20 text-center">
          <b>{{ $t('modals.deposit.qr4Txt') }}</b>
        </div>
        <div class="m-t-10">
          <button
            type="button"
            class="button small is-danger m-l-10"
            @click="clearQrcode"
          >
            {{ $t('modals.deposit.cancelBtn') }}
          </button>
          <button
            type="button"
            class="button small is-success m-l-10"
            @click="scanQrcode"
          >
            {{ $t('modals.deposit.transferBtn') }}
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="columns is-mobile">
        <div class="column is-5 is-one-third-mobile">
          <div class="svg"></div>
          <div class="m-t-15 bank-name-en text-center">
            <b>{{ depositAccount.bank.nameTH }}</b>
            <br />
            {{ depositAccount.bank.nameEN }}
          </div>
        </div>
        <div class="column is-7 is-two-third-mobile">
          <div class="qrcode-preview">
            <span>QR code</span>
          </div>
        </div>
      </div>
      <div class="m-t-20 text-center">
        {{ $t('modals.deposit.qrAmountTxt') }}
      </div>
      <div class="m-t-10">
        {{ $t('modals.deposit.qrCondition1Txt') }}<br />
        {{ $t('modals.deposit.qrCondition2Txt') }}
      </div>
      <div class="field display-flex m-t-20 justify-center">
        <div class="control has-icons-left">
          <input
            v-model="qrcodeAmount"
            type="number"
            :placeholder="$t('modals.deposit.amountPla')"
            class="input text-center"
          />
          <span class="icon is-left">
            <i class="fas fa-coins"></i>
          </span>
        </div>
        <b-button
          class="button small is-success m-l-10"
          @click="createQrcode"
          :loading="isQrCreating"
          :disabled="qrcodeAmount <= 0"
        >
          {{ $t('modals.deposit.qrCreateBtn') }}
        </b-button>
      </div>
      <div class="m-t-10 text-center">
        <b-button
          class="no-radius"
          v-for="(amount, index) in amountList"
          :key="index"
          outlined
          @click="selectQrcodeAmount(amount)"
        >
          {{ amount.toLocaleString() }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import i18n from '@/language'

import apiVerifyQrcode from '@/api/verify.qrcode'

export default {
  name: 'ModalDeposit',
  props: {
    depositAccount: {
      type: Object
    },
    refreshQrcode: {
      type: Object
    }
  },
  watch: {
    'refreshQrcode.KBANK': {
      handler(val) {
        if (val) {
          this.getQrcode()
          this.$emit('clearRefreshQrcode', this.depositAccount.bankCode)
        }
      }
    }
  },
  data() {
    return {
      checkQrcode: {
        qrcodeId: '',
        hasQrcode: false,
        qrcode: '',
        amount: 0,
        expireIn: ''
      },
      qrcodeAmount: null,
      amountList: [10, 20, 50, 100, 500, 1000],
      interval: null,
      timeInterval: null,
      isQrCreating: false
    }
  },
  created() {
    this.getQrcode()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    onCopy(e) {
      this.$buefy.toast.open({
        message: `Copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    },
    async getQrcode() {
      const data = await apiVerifyQrcode.getQrcode('KBANK')
      this.checkQrcode = data

      if (data && data.expireIn) this.countdown(this.checkQrcode.expireIn)
    },
    async scanQrcode() {
      this.$buefy.toast.open({
        message: i18n.t('modals.deposit.refreshAmountMsg'),
        type: 'is-success'
      })

      this.$emit('closeModal', null)
    },
    async createQrcode() {
      try {
        if (this.qrcodeAmount < 1) return

        this.isQrCreating = true

        const data = await apiVerifyQrcode.createQrcode('KBANK', {
          amount: this.qrcodeAmount
        })
        if (data.hasQrcode === false) {
          this.$buefy.toast.open({
            message: data.message,
            type: 'is-danger'
          })
        } else {
          this.checkQrcode = data
          if (data && data.expireIn) this.countdown(this.checkQrcode.expireIn)
        }

        this.$emit('updateRefreshQrcodeExcept', this.depositAccount.bankCode)
      } finally {
        this.isQrCreating = false
      }
    },
    async clearQrcode() {
      await apiVerifyQrcode.clearQrcode(this.checkQrcode.qrcodeId)
      this.checkQrcode = {
        qrcodeId: '',
        hasQrcode: false,
        qrcode: '',
        amount: 0,
        expireIn: ''
      }

      clearInterval(this.interval)
    },
    countdown(then) {
      this.interval = setInterval(() => {
        const now = new Date()
        const ms = moment(then).diff(moment(now))

        const d = moment.duration(ms)

        const minute = d.minutes() < 10 ? '0' + d.minutes() : d.minutes()
        const second = d.seconds() < 10 ? '0' + d.seconds() : d.seconds()

        this.timeInterval = `${minute}:${second}`

        if (this.timeInterval === '00:00') {
          this.checkQrcode.hasQrcode = false

          clearInterval(this.interval)
        }
      }, 1000)
    },
    selectQrcodeAmount(amount) {
      this.qrcodeAmount = amount
    }
  }
}
</script>

<style scoped lang="scss">
.no-radius {
  border-radius: 4px;
  padding: 2px 8px;
  margin: 3px 3px;
  font-weight: 400;
  font-size: 14px;
}
</style>
